import { Alert, AlertTitle, AlertDescription } from "@/components/ui/alert";
import { buttonVariants } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { Link } from "@tanstack/react-router";
import { AlertCircleIcon, ArrowRight } from "lucide-react";

export default function ErrorAlert({
  message,
  countryId,
  gradingScaleId,
}: {
  message: string;
  countryId: string;
  gradingScaleId: string;
}) {
  return (
    <Alert variant="destructive">
      <AlertCircleIcon />
      <AlertTitle>Error in extracting</AlertTitle>
      <AlertDescription className="flex">
        <p>{message}</p>
        <Link
          className={cn(
            buttonVariants({
              variant: "outline",
              className: "text-accent-foreground",
            })
          )}
          to="/dashboard"
          search={{
            countryId: Number(countryId),
            gradingScaleId,
            isManual: true,
          }}
        >
          <ArrowRight />
        </Link>
      </AlertDescription>
    </Alert>
  );
}
